import React, { useState, useEffect } from "react";

// SUIR
import {
  Modal,
  Tab,
  Button,
  Menu,
  Grid,
  Header,
  Input,
  Select,
  Divider,
  Table,
  Icon,
} from "semantic-ui-react";

// Library
import axios from "axios";

// Custom
import Sortable from "../../Shared/Sortable";

const ExportParcelsModal = ({ selectedFeatures, setOpen, configs }) => {
  const [active, setActive] = useState("csv");
  const [valid, setValid] = useState([]);
  const [label, setLabel] = useState("5160");
  const [offset, setOffset] = useState(0);
  const [submitted, setSubmitted] = useState(false);

  // console.log("export modal", { valid, selectedFeatures, offset, label });

  useEffect(() => {
    setValid(
      selectedFeatures
        .filter((record) => {
          return record.feature.attributes.MailAdd != "NOT AVAILABLE";
        })
        .map((record) => {
          return {
            address: record.feature.attributes.MailAdd,
            owner: record.feature.attributes.OwnerName,
          };
        })
        .filter(
          (value, index, self) =>
            index ===
            self.findIndex(
              (t) => t.address === value.address && t.owner === value.owner
            )
        )
    );
  }, selectedFeatures);

  const downloadFile = (file, filename, mime) => {
    const linkSource = `data:${mime};base64,${file}`;
    const downloadLink = document.createElement("a");
    const fileName = filename;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  const submitPDFExport = () => {
    // console.log("submit request", { label, offset });
    // submit(valid, label, offset);
    setSubmitted(true);
    axios
      .post(configs.generate_mailing_labels_url, {
        parcels: valid.map((parcel) => `${parcel.owner},${parcel.address}`),
        label,
        offset,
        authenticity_token: configs.token,
      })
      .then((res) => {
        if (res.data.status) {
          downloadFile(res.data.file, res.data.filename, "application/pdf");
        } else {
          alert("Error gnenerating Mailing Labels");
        }

        setSubmitted(false);
      });
  };

  const submitCSVExport = () => {
    // console.log("submit request", { selectedFeatures });
    // submit(valid, label, offset);
    setSubmitted(true);
    axios
      .post(configs.generate_csv_url, {
        parcels: selectedFeatures.map((record) => {
          return {
            parcel_no: record.feature.attributes.PARCEL_NO,
            owner_name: record.feature.attributes.OwnerName,
            site_address: record.feature.attributes.SiteAdd,
            mail_address: record.feature.attributes.MailAdd,
            current_values: record.feature.attributes.Total_A,
            past_values: record.feature.attributes.Total_T,
            property_class: record.feature.attributes.PropertyCl,
            net_taxes: record.feature.attributes.NetTax,
          };
        }),
        authenticity_token: configs.token,
      })
      .then((res) => {
        if (res.data.status) {
          downloadFile(res.data.file, res.data.filename, "text/csv");
        } else {
          alert("Error gnenerating Mailing Labels");
        }

        setSubmitted(false);
      });
  };

  return (
    <Modal
      onClose={() => setOpen(false)}
      open={true}
      closeOnDimmerClick={!submitted}
    >
      <Modal.Header style={{ fontSize: "1.1em" }}>
        Export {selectedFeatures.length} Parcels
      </Modal.Header>
      <Menu
        color={"black"}
        inverted
        borderless
        attached
        style={{ margin: 0, width: "100%" }}
      >
        <Menu.Item
          style={{ width: "50%", margin: 0, borderRadius: 0 }}
          name="csv"
          active={active === "csv"}
          onClick={() => setActive("csv")}
        >
          CSV
        </Menu.Item>
        <Menu.Item
          style={{ width: "50%", margin: 0, borderRadius: 0 }}
          name="label"
          active={active === "label"}
          onClick={() => setActive("label")}
        >
          Label
        </Menu.Item>
      </Menu>
      <Modal.Content style={{ padding: 0, margin: 0 }}>
        {active === "csv" ? (
          <RenderCSVExportTemplate
            selectedFeatures={selectedFeatures.map((record) => {
              return {
                parcel_no: record.feature.attributes.PARCEL_NO,
                owner: record.feature.attributes.OwnerName,
                address: record.feature.attributes.MailAdd,
              };
            })}
          />
        ) : (
          <RenderMailingLabelTemplate
            selectedFeatures={selectedFeatures}
            valid={valid}
            label={label}
            setLabel={setLabel}
            offset={offset}
            setOffset={setOffset}
          />
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button secondary onClick={() => setOpen(false)} disabled={submitted}>
          Cancel
        </Button>
        {active === "csv" ? (
          <Button
            content="Download CSV"
            loading={submitted}
            disabled={submitted}
            onClick={() => submitCSVExport()}
            primary
          />
        ) : (
          <Button
            content="Download PDF"
            loading={submitted}
            disabled={submitted}
            onClick={() => submitPDFExport()}
            primary
          />
        )}
      </Modal.Actions>
    </Modal>
  );
};

const RenderMailingLabelTemplate = ({
  selectedFeatures,
  valid,
  label,
  setLabel,
  offset,
  setOffset,
}) => {
  return (
    <div style={{ padding: "2em" }}>
      <Header as="h4" style={{ textAlign: "center" }}>
        {selectedFeatures.length} selected parcels,{" "}
        {selectedFeatures.length - valid.length} have valid invalid or duplicate
        mailing addresses
      </Header>
      <p>
        Generate a mailing list for a selected Avery label sheet or as CSV Data.
        Parcels that do not contain valid mailing addresses are not included.
      </p>
      <Divider />

      <Grid divided>
        <Grid.Row columns={2}>
          <Grid.Column>
            <p>
              If using an existing labelling sheet, please select the number of
              labels to offset to print correctly
            </p>
            <Input
              fluid
              type="number"
              value={offset}
              onChange={(e, { value }) => setOffset(parseInt(value))}
              min="0"
              max="29"
              step="1"
            />
          </Grid.Column>
          <Grid.Column>
            <p>
              Select an Avery template or CSV that can be used to create mailing
              labels in Microsoft Word.
            </p>

            <Select
              fluid
              value={label}
              onChange={(e, { value }) => setLabel(value)}
              options={[
                { key: "5160", value: "5160", text: "Avery 5160" },
                { key: "5161", value: "5161", text: "Avery 5161" },
              ]}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

const RenderCSVExportTemplate = ({ selectedFeatures }) => {
  // Pull in Sortable methods
  const { sortedRecords, sortRecords, sort, sortIcon } = Sortable();

  useEffect(() => {
    sortRecords(selectedFeatures);
    sort("parcel_no", "ascending");
  }, []);

  return (
    <Table celled attached style={{ width: "100%", margin: 0 }}>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell
            className="sortable"
            onClick={() => sort("parcel_no")}
          >
            Parcel NO <Icon name={sortIcon("parcel_no")} />
          </Table.HeaderCell>

          <Table.HeaderCell className="sortable" onClick={() => sort("owner")}>
            Owner <Icon name={sortIcon("owner")} />
          </Table.HeaderCell>
          <Table.HeaderCell
            className="sortable"
            onClick={() => sort("address")}
          >
            Address <Icon name={sortIcon("address")} />
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {sortedRecords.map((record, index) => {
          return (
            <Table.Row key={index}>
              <Table.Cell>{record.parcel_no}</Table.Cell>
              <Table.Cell>{record.owner}</Table.Cell>
              <Table.Cell>{record.address}</Table.Cell>
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table>
  );
};

export default ExportParcelsModal;
